export const ENTITY = "SERVICE_REGISTER";
